module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright",
    attrs: {
      "id": "cop"
    }
  }, [_c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("the barcelona cookbook")]), _vm._v(" copyright © 2009 by Sasa Mahr-Batuz and Andy Pforzheimer. All rights reserved. Printed in China. No part of this book may be used or reproduced in any manner whatsoever without written permission except in the case of reprints in the context of reviews. For information, write Andrews McMeel Publishing, LLC, an Andrews McMeel Universal company, 1130 Walnut Street, Kansas City, Missouri 64106.")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('span', [_vm._v("LIBRARY OF CONGRESS CATALOGING-IN-PUBLICATION DATA")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "pubhlink",
    attrs: {
      "href": "http://www.andrewsmcmeel.com",
      "target": "_blank"
    }
  }, [_vm._v("www.andrewsmcmeel.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Mahr-Batuz, Sasa."), _c('br'), _vm._v("The Barcelona cookbook: a celebration of food, wine, and life / by Sasa Mahr-Batuz and Andy Pforzheimer with Mary Goodbody; photography by John Blais.—1st ed."), _c('br'), _vm._v("   p. cm."), _c('br'), _vm._v("Includes index."), _c('br'), _vm._v("E-ISBN: 978-0-7407-9068-3"), _c('br'), _vm._v("1. Cookery, Spanish. 2. Cookery, Mediterranean. 3. Tapas. 4. Barcelona Restaurant and Wine Bar. I. Pforzheimer, Andy. II. Goodbody, Mary. III. Barcelona Restaurant and Wine Bar. IV. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("TX723.5.S7M2865 2009"), _c('br'), _vm._v("641.5946—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('span', [_vm._v("2008032696")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Design: Diane Marsh"), _c('br'), _vm._v("Food Styling: Jennifer Prichett")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Photos courtesy of Sasa Mahr-Batuz: i, v, x, xiv bottom, xv, xvi bottom, xvii, xviii right, xix, xx, xxii top right, 1, 9, 11, 12, 13, 14, 20, 21, 26 left and top right, 32, 34, 38, 39, 40-41, 43, 44, 49, 50, 59, 60, 61, 63, 65, 68-69, 70, 72 top, 81, 83, 98, 100, 105, 106, 111, 116, 117, 123, 127, 129, 132 right, 134 top right and left, 136, 139, 140, 155 right, 159 left, 161, 166, 171, 196")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Photos by Felipe Rodriguez: 84-85, 102-103")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "pubhlink",
    attrs: {
      "href": "http://www.barcelonawinebar.com",
      "target": "_blank"
    }
  }, [_vm._v("www.barcelonawinebar.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("attention: schools and businesses")]), _c('br'), _vm._v("Andrews McMeel books are available at quantity discounts with bulk purchase for educational, business, or sales promotional use. For information, please write to: Special Sales Department, Andrews McMeel Publishing, LLC, 1130 Walnut Street, Kansas City, Missouri 64106."), _c('br'), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "mailto:specialsales@amuniversal.com"
    }
  }, [_vm._v("specialsales@amuniversal.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Cover design by Tim Lynch and Cover photography by John Blais")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c79efe40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780740790683_epub_cop_r1.vue
// module id = 66
// module chunks = 0